import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from '@mui/material/styles'
import { AuthProvider, ServerClockProvider, SnackbarProvider, Telemetry, ThemeModeProvider } from '@jupi/ui'
import '@jupi/ui/i18n'
// Every mdi icon, bundled: the CSP blocks Iconify's API (packages/ui/vite/mdiIcons.ts).
import 'virtual:mdi-icons'
// Brand fonts, self-hosted (the CSP blocks Google Fonts).
import '@jupi/ui/fonts.css'
import App from './App'
import { tabletTheme } from './theme'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      // Back from another app on the tablet: show what is true now, not the
      // hours from before the last flight.
      refetchOnWindowFocus: true,
      retry: (failureCount, error) => {
        const status = (error as { status?: number }).status
        if (status && status < 500) return false
        return failureCount < 2
      },
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeModeProvider>
      {/* Inside ThemeModeProvider, which owns light/dark; a function theme
          is merged onto the outer one, so this follows its mode. */}
      <ThemeProvider theme={tabletTheme}>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <AuthProvider>
              <Telemetry app="huolto" />
              <SnackbarProvider>
                <ServerClockProvider>
                  <App />
                </ServerClockProvider>
              </SnackbarProvider>
            </AuthProvider>
          </BrowserRouter>
        </QueryClientProvider>
      </ThemeProvider>
    </ThemeModeProvider>
  </StrictMode>,
)
